import Titulo from '../../components/tipografia/Titulo';
import React from 'react';
import LayoutUsuario from '../../components/navegacao/LayoutUsuario';
import Descricao from '../../components/tipografia/Descricao';
import HBox from '../../components/layout/HBox';
import Botao from '../../components/Botao';
import VBox from '../../components/layout/VBox';
import CampoTexto from '../../components/Formulario/CampoTexto';
import Icon from '@/components/Icon';
import {
  mdiAccount,
  mdiAlertCircle,
  mdiCheck,
  mdiCheckAll,
  mdiFilter,
  mdiHeadset,
  mdiLoading,
  mdiMagnify,
  mdiRobot,
  mdiEyeCircleOutline,
  mdiDownload,
} from '@mdi/js';
import { toast } from 'react-toastify';
import DataTable, { DataTableHeader } from '../../components/layout/DataTable';
import { useInfiniteQuery } from 'react-query';
import axios from 'axios';
import { useDebounce } from '../chat/useDebounce';
import { format } from 'date-fns';
import IconeCanal from '../../components/layout/IconeCanal';
import Grid, { GridItem } from '../../components/layout/Grid';
import CampoData from '../../components/Formulario/CampoData';
import { FiltroCanais } from './FiltroCanais';
import { FiltroTipoMensagem } from './FiltroTipoMensagem';
import { FiltroEstadoMensagem } from './FiltroEstadoMensagem';
import { FiltroAtendente } from '@/components/Filtros/FiltroAtendente';
import FiltroGrupoUsuario from '@/components/Filtros/FiltroGrupoUsuario';
import { FiltroOrigemAtendimento } from './FiltroOrigemAtendimento';
import CampoMemo from '@/components/Formulario/CampoMemo';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Accordion } from '@/components/layout/Accordion';

type ResponseList = {
  status: number;
  ok?: boolean;
  result: any[];
  total: number;
  cursor: string | number | null;
};

type PageProps = {};

const Page = ({ }: PageProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [search, setSearch] = React.useState<string>('');
  const [filter, setFilter] = React.useState<any>({});
  const [filterDataIni, setFilterDataIni] = React.useState<string>('');
  const [filterDataFim, setFilterDataFim] = React.useState<string>('');
  const [filterCanais, setFilterCanais] = React.useState<string[]>([]);
  const [filterEstadoMensagem, setFilterEstadoMensagem] = React.useState<string[]>([]);
  const [filterAtendente, setFilterAtendente] = React.useState<string[]>([]);
  const [filterGrupoResponsavel, setFilterGrupoResponsavel] = React.useState<string[]>([]);

  const [filterTipoMensagem, setFiltroTipoMensagem] = React.useState<string[]>(
    [],
  );
  const [filterIdsNotificacao, setFilterIdsNotificacao] = React.useState<
    string[]
  >([]);
  const [filterIdsChat, setFilterIdsChat] = React.useState<string>(
    searchParams.getAll('ids').join(', ')
  );
  const [filterPeriodoAtendimento, setFilterPeriodoAtendimento] = React.useState<string>('');

  // Estados para exportação
  const [exportJobId, setExportJobId] = React.useState<number | null>(null);
  const [exportJobStatus, setExportJobStatus] = React.useState<string>('idle');
  const [exportJobProgress, setExportJobProgress] = React.useState(0);
  const [exportJobError, setExportJobError] = React.useState<string | null>(null);
  const [isExporting, setIsExporting] = React.useState(false);
  const exportPollRef = React.useRef<NodeJS.Timeout | null>(null);

  const stopExportPoll = () => {
    if (exportPollRef.current) {
      clearInterval(exportPollRef.current);
      exportPollRef.current = null;
    }
  };

  React.useEffect(() => {
    return () => {
      stopExportPoll();
    };
  }, []);

  const debouncedSearch = useDebounce(search, 500);

  const headers: DataTableHeader[] = [
    {
      label: '# Atend.',
      width: '5%',
      column: 'chat_id',
    },
    {
      label: 'Código',
      width: '5%',
      render: row => (
        <span>
          <IconeCanal tipo={row.canal_tipo} style={{ height: '16px' }} />
          {row.canal_cliente_id}
        </span>
      ),
    },
    {
      label: 'Cliente',
      width: '10%',
      render: row => <span>{row.nome}</span>,
    },
    {
      label: 'Mensagem',
      width: '40%',
      render: row => (
        <HBox>
          {row.origem === 'bot' && (
            <Icon
              path={mdiRobot}
              size={1}
              color="var(--tc-color-gray-500)"
              title="Chatbot"
            />
          )}
          {row.origem === 'usuario' && (
            <Icon
              path={mdiAccount}
              size={1}
              color="var(--tc-color-primary)"
              title="Cliente"
            />
          )}
          {row.origem === 'atendente' && (
            <Icon
              path={mdiHeadset}
              size={1}
              color="var(--tc-color-warning)"
              title="Atendente"
            />
          )}{' '}
          <div style={{ flex: 1 }}>{row.tipo_mime === 'text/message' ? row.conteudo_ou_url : '(arquivo)'}</div>
          {row.estado_atual === 'em_processamento' && (
            <Icon path={mdiLoading} size={1} color="var(--tc-color-gray-500)" />
          )}
          {row.estado_atual === 'processada' && (
            <Icon path={mdiCheck} size={1} color="var(--tc-color-info)" />
          )}
          {row.estado_atual === 'lida' && (
            <Icon path={mdiCheckAll} size={1} color="var(--tc-color-success)" />
          )}
          {row.estado_atual === 'erro' && (
            <Icon path={mdiAlertCircle} size={1} color="var(--tc-color-danger)" />
          )}
        </HBox>
      ),
    },
    {
      label: 'Atendente responsável',
      width: '10%',
      column: 'usuario_responsavel_nome',
    },
    {
      label: 'Data',
      width: '10%',
      render: row => format(new Date(row.data_criacao), 'dd/MM/yyyy HH:mm'),
    },
    {
      label: '',
      width: '48px',
      stickRight: true,
      alignRight: true,
      render: (row: any) => (
        <Botao
          variant="none-primary"
          icon={mdiEyeCircleOutline}
          title="Supervisionar IA"
          onClick={() => navigate(`/ia/supervisao?canal_id=${row.canal_id}&canal_cliente_id=${encodeURIComponent(row.canal_cliente_id ?? '')}`)}
        />
      ),
    },
  ];

  const queryList = useInfiniteQuery({
    queryKey: ['historico_mensagens', debouncedSearch, filterDataIni, filterDataFim, filterCanais, filterEstadoMensagem, filterAtendente, filterGrupoResponsavel, filterTipoMensagem, filterIdsNotificacao, filterIdsChat, filterPeriodoAtendimento],
    queryFn: async ({ pageParam }) => {
      console.warn('LOAD', pageParam)
      const where: Record<string, any> = {};
      if (filterDataIni && filterDataFim) {
        where['chat_mensagem.data_criacao'] = [
          'between',
          [filterDataIni, filterDataFim],
        ];
      } else if (filterDataIni) {
        where['chat_mensagem.data_criacao'] = ['ge', new Date(filterDataIni)];
      } else if (filterDataFim) {
        where['chat_mensagem.data_criacao'] = ['le', filterDataFim];
      }

      if (filterCanais.length > 0) {
        where['chat.canal_id'] = ['in', filterCanais];
      }

      // Sem estado selecionado = todos (o endpoint não impõe default de estado).
      if (filterEstadoMensagem.length > 0) {
        where['chat_mensagem.estado_atual'] = ['in', filterEstadoMensagem];
      }

      if (filterAtendente.length > 0) {
        where['usuario_responsavel_id'] = ['in', filterAtendente];
      }

      if (filterGrupoResponsavel.length > 0) {
        where['grupo_responsavel_id'] = ['in', filterGrupoResponsavel];
      }

      if (filterTipoMensagem.length === 1) {
        if (filterTipoMensagem[0] === 'message')
          where['chat_mensagem.mensagem_programada_id'] = ['eq', null];
        else if (filterTipoMensagem[0] === 'notification')
          where['chat_mensagem.mensagem_programada_id'] = ['ne', null];
      }

      if (filterIdsNotificacao.length > 0) {
        where['chat_mensagem.mensagem_programada_id'] = [
          'in',
          filterIdsNotificacao,
        ];
      }

      if (filterIdsChat) {
        const ids = filterIdsChat
          .split(/[,\n]/)
          .map(id => id.trim())
          .filter(id => id && !isNaN(Number(id)))
          .map(Number);

        if (ids.length > 0) {
          where['chat_mensagem.chat_id'] = ['in', ids];
        }
      }

      if (filterPeriodoAtendimento) {
        where['periodo_atendimento'] = ['eq', filterPeriodoAtendimento];
      }

      const params = new URLSearchParams({
        txt: debouncedSearch,
        c: pageParam,
        fi: JSON.stringify(where),
      });

      return await axios.get('/api/chat_mensagem?' + params.toString(), {
        withCredentials: true,
      });
    },
    getNextPageParam: lastPage => lastPage.data?.cursor ?? null,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0,
    refetchInterval: 0,
  });

  const total = queryList.data?.pages?.[0]?.data?.total ?? 0;

  const triggerExportDownload = async (jobId: number, filename: string) => {
    try {
      const response = await axios.get(
        `/api/chat_mensagem/export/${jobId}/download`,
        { responseType: 'blob', withCredentials: true },
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'historico-mensagens.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast('Mensagens exportadas com sucesso!', {
        type: 'success',
        position: 'top-center',
      });
    } catch (error: any) {
      console.error('Erro ao baixar arquivo:', error);
      toast('Erro ao baixar arquivo', {
        type: 'error',
        position: 'top-center',
      });
    }
  };

  const handleExportCSV = async () => {
    try {
      const where: Record<string, any> = {};
      if (filterDataIni && filterDataFim) {
        where['chat_mensagem.data_criacao'] = [
          'between',
          [filterDataIni, filterDataFim],
        ];
      } else if (filterDataIni) {
        where['chat_mensagem.data_criacao'] = ['ge', new Date(filterDataIni)];
      } else if (filterDataFim) {
        where['chat_mensagem.data_criacao'] = ['le', filterDataFim];
      }

      if (filterCanais.length > 0) {
        where['chat.canal_id'] = ['in', filterCanais];
      }

      // Sem estado selecionado = todos (o endpoint não impõe default de estado).
      if (filterEstadoMensagem.length > 0) {
        where['chat_mensagem.estado_atual'] = ['in', filterEstadoMensagem];
      }

      if (filterAtendente.length > 0) {
        where['usuario_responsavel_id'] = ['in', filterAtendente];
      }

      if (filterGrupoResponsavel.length > 0) {
        where['grupo_responsavel_id'] = ['in', filterGrupoResponsavel];
      }

      if (filterTipoMensagem.length === 1) {
        if (filterTipoMensagem[0] === 'message')
          where['chat_mensagem.mensagem_programada_id'] = ['eq', null];
        else if (filterTipoMensagem[0] === 'notification')
          where['chat_mensagem.mensagem_programada_id'] = ['ne', null];
      }

      if (filterIdsNotificacao.length > 0) {
        where['chat_mensagem.mensagem_programada_id'] = [
          'in',
          filterIdsNotificacao,
        ];
      }

      if (filterIdsChat) {
        const ids = filterIdsChat
          .split(/[,\n]/)
          .map(id => id.trim())
          .filter(id => id && !isNaN(Number(id)))
          .map(Number);

        if (ids.length > 0) {
          where['chat_mensagem.chat_id'] = ['in', ids];
        }
      }

      if (filterPeriodoAtendimento) {
        where['periodo_atendimento'] = ['eq', filterPeriodoAtendimento];
      }

      setIsExporting(true);
      setExportJobStatus('pendente');
      setExportJobProgress(0);
      setExportJobError(null);

      const { data } = await axios.post('/api/chat_mensagem/export', {
        search: debouncedSearch,
        filter: where,
      }, { withCredentials: true });

      const jobId: number = data.job_id;
      setExportJobId(jobId);

      toast('Exportação iniciada! Acompanhe o progresso abaixo.', { type: 'info', position: 'top-center' });

      // Iniciar polling
      exportPollRef.current = setInterval(async () => {
        try {
          const { data: statusData } = await axios.get(`/api/chat_mensagem/export/${jobId}/status`, { withCredentials: true });
          setExportJobStatus(statusData.status);
          setExportJobProgress(statusData.progresso ?? 0);

          if (statusData.status === 'concluido') {
            stopExportPoll();
            await triggerExportDownload(jobId, statusData.filename);
            setIsExporting(false);
            setExportJobId(null);
            setExportJobStatus('idle');
            setExportJobProgress(0);
          } else if (statusData.status === 'erro') {
            stopExportPoll();
            setExportJobError(statusData.erro_mensagem ?? 'Erro ao exportar mensagens');
            toast(statusData.erro_mensagem ?? 'Erro ao exportar mensagens', { type: 'error', position: 'top-center' });
            setIsExporting(false);
          }
        } catch (err) {
          console.error('Erro ao verificar status do export:', err);
        }
      }, 2000);

    } catch (error: any) {
      console.error('Erro ao iniciar exportação:', error);
      setExportJobStatus('erro');
      setExportJobError(error.response?.data?.msg ?? 'Erro ao iniciar exportação');
      toast(error.response?.data?.msg ?? 'Erro ao iniciar exportação', { type: 'error', position: 'top-center' });
      setIsExporting(false);
    }
  };

  return (
    <LayoutUsuario>
      <VBox gap="16px" style={{ height: 'calc(100vh - 32px)' }}>
        {/* Header */}
        <HBox>
          <VBox>
            <Titulo>Histórico de mensagens</Titulo>
            <Descricao>
              Pesquise aqui as mensagens trocadas no sistema
            </Descricao>
          </VBox>
        </HBox>

        {/* Filtros */}
        <Grid>
          <GridItem sm={12}>
            <HBox style={{ alignItems: 'flex-end' }} gap="8px">
              <CampoTexto
                label="&nbsp;"
                prepend={
                  <Icon
                    path={mdiMagnify}
                    size={1}
                    color="var(--tc-color-gray-500)"
                  />
                }
                placeholder="Pesquisar"
                value={search}
                onChange={setSearch}
              />
              <Botao variant="primary" onClick={() => queryList.refetch()}>
                Aplicar
              </Botao>
              <Botao
                variant="outline-primary"
                icon={mdiDownload}
                onClick={handleExportCSV}
                disabled={isExporting}
                title={isExporting ? `Exportando... ${exportJobProgress}%` : "Exportar mensagens em CSV"}
              >
                {isExporting ? `Exportando ${exportJobProgress}%` : 'Exportar CSV'}
              </Botao>
            </HBox>
          </GridItem>
        </Grid>

        <Accordion title={<HBox><Icon path={mdiFilter} size={1} />Filtros avançados</HBox>} startOpen={false}>
          <Grid>
            <GridItem sm={12} md={3}>
              <CampoData
                type="datetime-local"
                label="Data início"
                value={filterDataIni}
                onChange={setFilterDataIni}
              />
            </GridItem>
            <GridItem sm={12} md={3}>
              <CampoData
                type="datetime-local"
                label="Data fim"
                value={filterDataFim}
                onChange={setFilterDataFim}
              />
            </GridItem>

            <GridItem sm={12} md={6}>
              <FiltroCanais value={filterCanais} onChange={setFilterCanais} />
            </GridItem>

            <GridItem sm={6}>
              <FiltroEstadoMensagem value={filterEstadoMensagem} onChange={setFilterEstadoMensagem} />
            </GridItem>

            <GridItem sm={6}>
              <FiltroAtendente value={filterAtendente} onChange={setFilterAtendente} />
            </GridItem>

            <GridItem sm={6}>
              <FiltroGrupoUsuario value={filterGrupoResponsavel} onChange={setFilterGrupoResponsavel} />
            </GridItem>

            <GridItem sm={6}>
              <FiltroTipoMensagem
                value={filterTipoMensagem}
                onChange={setFiltroTipoMensagem}
                idValues={filterIdsNotificacao}
                onChangeValues={setFilterIdsNotificacao}
              />
            </GridItem>

            <GridItem sm={6}>
              <FiltroOrigemAtendimento
                value={filterPeriodoAtendimento}
                onChange={setFilterPeriodoAtendimento}
              />
            </GridItem>

            <GridItem sm={12}>
              <CampoMemo
                label="IDs de Atendimentos (separados por vírgula ou quebra de linha)"
                placeholder="Ex: 123, 456, 789"
                value={filterIdsChat}
                onChange={setFilterIdsChat}
                rows={3}
              />
            </GridItem>
          </Grid>
        </Accordion>

        {queryList.isFetching && (
          <div>
            Aguarde...{' '}
            <Icon
              path={mdiLoading}
              size={1}
              color="var(--tc-color-gray-700)"
              spin
            />
          </div>
        )}
        {!queryList.isFetching && (
          <div>
            Exibindo{' '}
            {queryList.data?.pages?.reduce(
              (acc, page) => acc + (page.data?.result?.length ?? 0),
              0,
            ) ?? '0'}{' '}
            de {+total} resultados.
          </div>
        )}

        <DataTable
          isLoading={queryList.isFetching}
          cabecalhos={headers}
          hasMoreData={queryList.hasNextPage}
          onLoadMore={async () => { console.warn('load mor!!'); queryList.fetchNextPage() }}
          paginas={queryList.data?.pages ?? []}
          aoObterPagina={(page: any): any[] => page.data.result}
        />
      </VBox>
    </LayoutUsuario>
  );
};

export default Page;
